export default __webpack_public_path__ + "media/images/upsell-benefit-icon-57f9c8f2.svg";